import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SearchBar = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const SearchInput = styled.div`
  flex: 1;
  position: relative;

  input {
    width: 100%;
    padding: 10px 12px 10px 40px;
    font-size: 14px;
    border: 1px solid ${(props) => props.theme.colors?.border || "#E5E7EB"};
    border-radius: 8px;
    background: ${(props) => props.theme.colors?.background || "#FFFFFF"};
    color: ${(props) => props.theme.colors?.text || "#111827"};
    transition: border-color 0.2s ease;

    &:focus {
      outline: none;
      border-color: ${(props) => props.theme.colors?.primary || "#3B82F6"};
    }

    &::placeholder {
      color: ${(props) => props.theme.colors?.textSecondary || "#9CA3AF"};
    }
  }

  svg {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    color: ${(props) => props.theme.colors?.textSecondary || "#9CA3AF"};
  }
`;

export const SelectionInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-radius: 8px;
  background: ${(props) => props.theme.colors?.primaryLight || "#EFF6FF"};
`;

export const SelectionCount = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => props.theme.colors?.primary || "#3B82F6"};
`;

export const SelectionActions = styled.div`
  display: flex;
  gap: 12px;

  button {
    font-size: 14px;
    color: ${(props) => props.theme.colors?.primary || "#3B82F6"};
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const TableContainer = styled.div`
  border: 1px solid ${(props) => props.theme.colors?.border || "#E5E7EB"};
  border-radius: 8px;
  overflow: hidden;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const TableHeader = styled.thead`
  background: ${(props) => props.theme.colors?.backgroundSecondary || "#F9FAFB"};

  th {
    padding: 12px 16px;
    font-size: 12px;
    font-weight: 600;
    text-align: left;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: ${(props) => props.theme.colors?.textSecondary || "#6B7280"};
    border-bottom: 1px solid ${(props) => props.theme.colors?.border || "#E5E7EB"};
  }
`;

export const TableBody = styled.tbody`
  tr {
    cursor: pointer;
    transition: background 0.1s ease;

    &:hover {
      background: ${(props) => props.theme.colors?.backgroundSecondary || "#F9FAFB"};
    }

    &:not(:last-child) {
      border-bottom: 1px solid ${(props) => props.theme.colors?.border || "#E5E7EB"};
    }
  }

  td {
    padding: 12px 16px;
    font-size: 14px;
    color: ${(props) => props.theme.colors?.text || "#111827"};
  }
`;

export const Checkbox = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: ${(props) => props.theme.colors?.primary || "#3B82F6"};
`;

export const ContactName = styled.div`
  font-weight: 500;
`;

export const ContactEmail = styled.div`
  font-size: 13px;
  color: ${(props) => props.theme.colors?.textSecondary || "#6B7280"};
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px;
  text-align: center;

  svg {
    width: 48px;
    height: 48px;
    color: ${(props) => props.theme.colors?.textSecondary || "#9CA3AF"};
    margin-bottom: 16px;
  }

  p {
    font-size: 14px;
    color: ${(props) => props.theme.colors?.textSecondary || "#6B7280"};
    margin: 0;
  }
`;

export const LoadingState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;
`;

export const Pagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-top: 1px solid ${(props) => props.theme.colors?.border || "#E5E7EB"};
  background: ${(props) => props.theme.colors?.backgroundSecondary || "#F9FAFB"};
`;

export const PaginationInfo = styled.span`
  font-size: 14px;
  color: ${(props) => props.theme.colors?.textSecondary || "#6B7280"};
`;

export const PaginationButtons = styled.div`
  display: flex;
  gap: 8px;

  button {
    padding: 8px 12px;
    font-size: 14px;
    border: 1px solid ${(props) => props.theme.colors?.border || "#E5E7EB"};
    border-radius: 6px;
    background: ${(props) => props.theme.colors?.background || "#FFFFFF"};
    color: ${(props) => props.theme.colors?.text || "#111827"};
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
      border-color: ${(props) => props.theme.colors?.primary || "#3B82F6"};
      color: ${(props) => props.theme.colors?.primary || "#3B82F6"};
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 16px;
`;
